import React from 'react';
import { motion } from 'framer-motion';
import './privacypolicy.css';

const PriPolicy = () => {
  return (
    <motion.div
      className="privacy-policy"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
      >
        Privacy Policy
      </motion.h1>
      
      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
      >
        <h2>1. Introduction</h2>
        <p>
          Welcome to ARCITY. Your privacy is critically important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.4 }}
      >
        <h2>2. Information We Collect</h2>
        <p>
          We collect personal information that you voluntarily provide to us when you register on the site, make a booking, or contact us. This includes:
        </p>
        <ul>
          <li>Name</li>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>Payment Information</li>
        </ul>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.6 }}
      >
        <h2>3. How We Use Your Information</h2>
        <p>
          We use the information we collect to:
        </p>
        <ul>
          <li>Process your bookings and transactions.</li>
          <li>Respond to your inquiries and provide customer service.</li>
          <li>Send you updates, marketing communications, and promotional materials.</li>
          <li>Improve our services and website functionality.</li>
        </ul>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.8 }}
      >
        <h2>4. Sharing Your Information</h2>
        <p>
          We may share your information with third-party service providers who assist us in operating our website, conducting business, and serving you. These third parties are obligated to protect your information and use it only for the purpose of providing their services.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.0 }}
      >
        <h2>5. Data Security</h2>
        <p>
          We use administrative, technical, and physical security measures to protect your personal information. However, no method of transmission over the internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.2 }}
      >
        <h2>6. Your Rights</h2>
        <p>
          You have the right to:
        </p>
        <ul>
          <li>Access, update, or delete your personal data.</li>
          <li>Object to the processing of your personal data.</li>
          <li>Request the restriction of the processing of your personal data.</li>
          <li>Request the transfer of your personal data.</li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at [arcityofficial@gmail.com].
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.4 }}
      >
        <h2>7. Cookies</h2>
        <p>
          We may use cookies and similar tracking technologies to access or store information. Cookies help us understand how our site is being used and improve your user experience.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.6 }}
      >
        <h2>8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date. We encourage you to review this policy periodically to stay informed about how we are protecting your information.
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 1.8 }}
      >
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at arcityofficial@gmail.com or +92 3009402541.
        </p>
      </motion.section>
    </motion.div>
  );
};

export default PriPolicy;
